export default __webpack_public_path__ + "static/media/eurosem.4783912d.jpg";